// stores/modalStore.js
import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
    state: () => ({
        homeIndicatorStyle : {},
        searchHistory:[],
        hotKeywordTimestamp:Date.now(),
        hotKeywords:[]
    }),
    actions: {
        setHomeIndicatorStyle(k, v){
            this.homeIndicatorStyle[k] = v;
            console.log(this.homeIndicatorStyle)
        },
        setSearchHistory(searchHistory){
            this.searchHistory = searchHistory
        },
        setHotKeywords(hotKeywords){
            this.hotKeywordTimestamp = Date.now();
            this.hotKeywords = hotKeywords;
        },
    },
    persist: {
        enabled: true,
    },
});
